const titleize = (sentence) => {
  if (!sentence.split) {
    return sentence
  }
  const formatWord = (string) => `${string.charAt(0).toUpperCase()}${string.slice(1).toLowerCase()}`;
  const result = [];

  sentence.split(' ').forEach((word) => {
      result.push(formatWord(word));
  });
  
  return result.join(' ');
}

export default titleize